import AuthLayout from "../../layout/authLayout";
import { Formik } from "formik";
import * as Yup from "yup";
import Input from "../../components/input";
import Button from "../../components/button";
import { useNavigate } from "react-router-dom";

const validationSchema = Yup.object().shape({
  password: Yup.string().required("Password is required."),
  confirmPassword: Yup.string().required("Confirm password is required."),
});
const initialValues = {
  password: "",
  confirmPassword: "",
};

const NewPassword = () => {
  const navigate = useNavigate();
  return (
    <>
      <AuthLayout
        title="Set New Password"
        subTitle="Your new password must be different to previously used password"
      >
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={() => {}}
          validateOnBlur
        >
          {({
            values,
            errors,
            touched,
            handleSubmit,
            setFieldTouched,
            setFieldValue,
            isSubmitting,
          }) => {
            return (
              <form onSubmit={handleSubmit}>
                <div className="p-2">
                  <Input
                    label="Password"
                    containerClass="w-full"
                    placeholder="Password"
                    name="password"
                    type="password"
                    error={errors.password}
                    touched={touched.password}
                    variant="solid"
                  />
                  <Input
                    label="Confirm Password"
                    containerClass="w-full"
                    placeholder="Confirm Password"
                    name="confirmPassword"
                    type="password"
                    error={errors.confirmPassword}
                    touched={touched.confirmPassword}
                    variant="solid"
                  />
                </div>

                <Button
                  className="ml-0 block  w-full bg-blue mt-4 mb-3"
                  loading={isSubmitting}
                  type="submit"
                >
                  Change Password
                </Button>
                <p
                  className="text-blue font-semibold text-center cursor-pointer ml-1"
                  onClick={() => navigate("/")}
                >
                  Back To Login
                </p>
              </form>
            );
          }}
        </Formik>
      </AuthLayout>
    </>
  );
};
export default NewPassword;
